import { useRef } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApp } from '@/hooks/use-app-context';
import { isConsentGranted } from './collection-place.contract';
import { collectionPlaceService } from './collection-place.service';

export function useGeolocationConsentSettings() {
  const { user, setUser } = useApp();
  const queryClient = useQueryClient();
  const currentUserId = useRef(user?.id);
  currentUserId.current = user?.id;

  const mutation = useMutation({
    mutationFn: collectionPlaceService.recordConsent,
    onSuccess: async (consent) => {
      if (!user || currentUserId.current !== user.id) return;
      setUser({
        ...user,
        geolocationConsent: {
          decision: consent.geolocationConsent,
          version: consent.geolocationConsentVersion,
          at: consent.geolocationConsentAt,
        },
      });
      if (consent.geolocationConsent === 'denied') {
        const queryKey = ['geo', 'reverse', user.id];
        await queryClient.cancelQueries({ queryKey });
        queryClient.removeQueries({ queryKey });
      }
    },
  });

  return {
    isGranted: isConsentGranted(user?.geolocationConsent),
    isSaving: mutation.isPending,
    hasError: mutation.isError,
    updateConsent: (decision: 'granted' | 'denied') => mutation.mutate(decision),
  };
}
